declare global {
  interface Array<T> {
    isEmpty(): boolean;
    isNotEmpty(): boolean;
  }
}

Array.prototype.isEmpty = function (this: Array<any>): boolean {
  return this.length === 0;
};
Array.prototype.isNotEmpty = function (this: Array<any>): boolean {
  return this.length !== 0;
};

export {};
